import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    muiAppBar: {
      backgroundColor: theme.palette.common.white,
      color: theme.typography.body2.color,
    },
    toolbar: {
      maxWidth: theme.maxContainerWidth,
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
    },
  }),
  { name: 'MobileNavBar' }
);
